import { Chip } from '@jotpsych/ui';

import { STATE_TOKENS } from '../stateTokens';
import type { PayerState } from '../types';

export interface StateChipProps {
  state: PayerState;
  /** Override the default state label (e.g. a summary chip prefixes a count). */
  label?: string;
}

/**
 * A single payer's folded state, rendered as a Chip (variant="soft",
 * size="xSmall") with the design's exact hex tokens applied via `sx`.
 * Covers all five states: needs_us, needs_customer, waiting, ready, live.
 */
export function StateChip({ state, label }: StateChipProps) {
  const tokens = STATE_TOKENS[state];
  return (
    <Chip
      label={label ?? tokens.label}
      variant="soft"
      size="xSmall"
      sx={{
        backgroundColor: tokens.bg,
        borderColor: tokens.border,
        color: tokens.text,
        border: '1px solid',
        fontWeight: 600,
      }}
    />
  );
}
